export default {
  "Tab.Title": "パーソナルデータダッシュボード (法人のお客さま向け)",
}
